import { render, staticRenderFns } from "./shopIndex.vue?vue&type=template&id=07f0262b&scoped=true"
import script from "./shopIndex.vue?vue&type=script&lang=js"
export * from "./shopIndex.vue?vue&type=script&lang=js"
import style0 from "./shopIndex.vue?vue&type=style&index=0&id=07f0262b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0262b",
  null
  
)

export default component.exports